import { SiteInfo } from "./siteAboutInterfaces";
import {
  FlexScheduleWithTimes,
  isFleetSite,
  presetConflictsAlertText,
} from "../FlexIgnoreZonesOnboarding/flexPresetConflicts";

/**
 * ENG-1927: before a flex_schedule PATCH, refuse the save when a camera would
 * run two different presets at once on a fleet site (admin's ENG-1914 rule).
 * Checked before the PATCH because the preset rows are written one by one
 * after it, and admin would refuse part-way through. Returns true (and has
 * alerted) when the save must stop. Dynamic import avoids a circular
 * dependency between siteAboutStore and flexIgnoreZonesOnboardingStore.
 */
export async function blockOnFlexPresetConflicts(
  siteInfo: Pick<SiteInfo, "id" | "deployment_target" | "is_fleet_site">,
  flexSchedules: FlexScheduleWithTimes[]
): Promise<boolean> {
  if (!isFleetSite(siteInfo)) {
    return false;
  }
  try {
    const { useFlexIgnoreZonesOnboardingStore } = await import(
      "../FlexIgnoreZonesOnboarding/flexIgnoreZonesOnboardingStore"
    );
    const conflicts = useFlexIgnoreZonesOnboardingStore
      .getState()
      .getPresetConflictsForSite(siteInfo.id, flexSchedules);
    if (conflicts.length === 0) {
      return false;
    }
    alert(presetConflictsAlertText(conflicts));
    return true;
  } catch {
    // The server check still applies; don't block the save on a client error.
    return false;
  }
}
